import { paramsToString } from '@/services/http/httpClient'
import billmaHttpClient from '@/services/http/billmaHttpClient'
import * as Settings from '@/infra/settings'

export const apiCreateSinister = sinisterInfo => {
  const params = new URLSearchParams()
  params.append('locale', Settings.getLocale())

  return billmaHttpClient.post(`/claims/selfcare-link${paramsToString(params)}`, sinisterInfo)
    .then(data => data)
    .catch(error => Promise.reject(error))
}
